import React, { useContext, useEffect } from "react";
import { focusOnAnyBttnElement } from "./utils";
import {
  SideBarMenuContextValue,
  SideBarMenuContext,
} from "./sidebar-menu-context-provider";
import { Link } from "react-router-dom";
import "./sidebar-menu.css";

export interface MenuItemProps {
  /**
   * Unique ID used for event handling, must be unique across the entire DOM.
   */
  uniqueId: string;
  /**
   * Translated strings displayed for the item
   */
  name: string;
  /**
   * Type of the menu item that can only match any of the specified types
   */
  itemType: "internalLink" | "externalLink" | "mainMenuItem" | "line";
  /**
   * Value of the url for the link
   */
  to?: string;
  /**
   * Value of the url to get the icon image
   */
  iconSrc?: string;
  /**
   *If the menu item needs to display a sub menu the required iformation of the sub menu items goes here
   */
  subMenuItems?: MenuItemProps[];
  /**
   *If the current item has a mainMenuItem we use this value to track that
   */
  mainMenuItem?: MenuItemProps;
  /**
   * Size of the screen where the nav bar will be displayed
   */
  screenSize?: string;
}

export function MenuItem(props: MenuItemProps) {
  const { uniqueId, name, iconSrc, to, itemType, mainMenuItem, subMenuItems, screenSize, ...htmlProps } = props;

  const {
    setSelectedItemSubmenu,
    selectedItemSubmenu,
    setSelectedItemMainMenu,
    selectedItemMainMenu,
    hideBar
  } = useContext<SideBarMenuContextValue>(SideBarMenuContext);

  useEffect(() => {
    if (selectedItemSubmenu) {
      focusOnAnyBttnElement(selectedItemSubmenu.uniqueId)
    }
  }, [selectedItemSubmenu])

  useEffect(() => {
    if (!hideBar && selectedItemMainMenu && screenSize !== 'lg') {
      focusOnAnyBttnElement(selectedItemMainMenu?.uniqueId)
    }
  }, [hideBar])

  const handleBttnLinkClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const linkElement = document.getElementById(`${uniqueId}-link`);
    linkElement?.click();
    handleItemClick();
  };

  const handleItemClick = () => {
    if (itemType === "mainMenuItem") {
      setSelectedItemMainMenu(props);
    } else {
      setSelectedItemSubmenu(props);
      if (!mainMenuItem) {
        setSelectedItemMainMenu(undefined);
      }
    }
  };

  switch (itemType) {
    case "mainMenuItem":
      return (
        <button
          className={`menuitem-button
            ${selectedItemMainMenu?.uniqueId === uniqueId ? "active-menu-item" : ""}`}
          onClick={handleItemClick}
          data-testid={`${uniqueId}-button`}
          id={`${uniqueId}-button`}
          role="menuitem"
        >
          {iconSrc && <img className="menuitem-icon" src={iconSrc} alt="" />}
          {name}
        </button>
      );
      break;
    case "internalLink":
      return (
        <>
          <button
            className={`menuitem-button ${selectedItemSubmenu?.uniqueId === uniqueId ? "active-menu-item" : ""
              }`}
            onClick={handleBttnLinkClick}
            data-testid={`${uniqueId}-button`}
            id={`${uniqueId}-button`}
            tabIndex={0}
            role="menuitem"
          >
            {iconSrc && <img className="menuitem-icon" src={iconSrc} alt="" />}
            {name}
          </button>
          {to && (
            <Link
              className="menuitem-link"
              to={to}
              id={`${uniqueId}-link`}
              data-testid={`${uniqueId}-link`}
            />
          )}
        </>
      );

      break;
    case "line":
      return <hr className="navbar-hr" role="none" />;
      break;
    default:
      return (
        <>
          <button
            className={`menuitem-button ${selectedItemSubmenu?.uniqueId === uniqueId ? "active-menu-item" : ""
              }`}
            onClick={handleBttnLinkClick}
            data-testid={`${uniqueId}-button`}
            id={`${uniqueId}-button`}
            tabIndex={0}
            role="menuitem"
          >
            {iconSrc && <img className="menuitem-icon" src={iconSrc} alt="" />}
            {name}
          </button>
          {to && (
            <a
              className="menuitem-link"
              href={to}
              id={`${uniqueId}-link`}
            ></a>
          )}
        </>
      );
      break;
  }
}
